
export const downloadCSV = (base64,fileName) => {
  if (base64) {
    let csvContent = atob(base64);
    var blob = new Blob([csvContent], {type: "data:application/octet-stream;base64"});
    var url  = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.download = fileName+".csv";
    link.href = url;
    link.click();

  }
};
